module.exports = "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <button class=\"btn btn-success\">New Recipe</button>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <app-recipe-item \r\n        *ngFor=\"let recipeEl of recipies\" \r\n        [recipe]=\"recipeEl\">\r\n    </app-recipe-item>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/gitHub/cookbook/src/app/components/recipe-book/recipe-list/recipe-list.component.html
// module id = ../../../../../src/app/components/recipe-book/recipe-list/recipe-list.component.html
// module chunks = main